//----- Component --------------------------------------------------------/

// Developer :  Nicolas Pascucci

// Creation Date : 11/02/2025

// Version : 1

// Description : Tabla de tipos de prendas

//

//------Changes --------------------------------------------------------------------- -------------//

// Change Date :

// Change by :

// Change description:

//

// Change Date :

// Change by :

// Change description:

//
//========================================================================/
import React, { useState, useEffect, useMemo, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { logEventos } from "../../../services/services";
import MaterialReactTable, {
  MRT_FullScreenToggleButton,
} from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es"; //Tabla en español
import {
  Container,
  Box,
  Typography,
  IconButton,
  Tooltip,
} from "@mui/material";
import { createTheme, ThemeProvider, useTheme } from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import Navbar from "../../Navbar";
// ICONOS
import HomeRepairServiceIcon from "@mui/icons-material/HomeRepairService";
import CheckroomIcon from '@mui/icons-material/Checkroom';
import { getData } from "../../../services/library";
import EditIcon from "@mui/icons-material/Edit";
import EdicionPrenda from "./EdicionPrenda";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function Prendas_rrhh(props) {
  let navigate = useNavigate();
  const [editar, setEditar] = useState(false); //Estado q mostrará o no el form de edicion de clientes
  const [prenda, setPrenda] = useState()
  const location = useLocation();
  const [prendas, setPrendas] = useState();
  const [tabla, setTabla] = useState(true);
  // console.log(location.state.id);

  const obtenerPrendas = () => {
      getData("/stock_tipos_prendas/", setPrendas);
  };

  useEffect(() => {
    obtenerPrendas();
  }, [tabla]);

  // console.log("vehiculos", vehiculos);

  const handleClose = () => {
    setEditar(false);
    obtenerPrendas()
  };

  const columns = useMemo(
    () => [
      { header: "ID", accessorKey: "id", size: 95 },
      { header: "Nombre", accessorKey: "nombre", size: 95 },
      { header: "Descripción", accessorKey: "descripcion", size: 100 },
    ],
    []
  );
  
    const muiSearchTextFieldProps = {
      placeholder: "Buscar..",
      sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
      variant: "outlined",
      color: "primary",
      size: "small",
    };
    const tableHeadCellProps = {
      align: "left",
      sx: {
        fontSize: 16,
        color: "white",
        fontWeight: "normal",
        backgroundColor: "#2471A3",
        borderColor: "black",
      },
    };
    //*************************************************************************************************************************************//
    const globalTheme = useTheme();
    const tableTheme = useMemo(
      () =>
        createTheme({
          palette: {
            mode: globalTheme.palette.mode,
            primary: globalTheme.palette.primary, //primary color for the table
            info: {
              main: "rgb(255,122,0)", //add in a custom color for the toolbar alert background stuff
            },
            background: {
              default:
                globalTheme.palette.mode === "light"
                  ? "rgb(234, 239, 241)"
                  : "#000", //pure black table in dark mode for fun
            },
          },
          typography: {
            button: {
              textTransform: "none", //customize typography styles for all buttons in table by default
              fontSize: "1rem",
            },
          },
          components: {
            MuiTooltip: {
              styleOverrides: {
                tooltip: {
                  fontSize: "0.8rem",
                },
              },
            },
          },
        }),
      [globalTheme]
    );
  
    const initialState = {
      density: "compact",
      showGlobalFilter: true,
      pagination: { pageIndex: 0, pageSize: 10 },
    };
  
    useEffect(() => {
  logEventos(
    "acceso al menú Tipos de Prendas",
   "Stock Materiales",
    "Tipos de Prendas",
     localStorage.getItem("user"));
}, []);
    return (
      <>
        <Navbar/>
        <Container maxWidth="xl" mt={1}>
          {prendas && tabla ? (
            <Box mt={2} mb={4}>
              <ThemeProvider theme={tableTheme}>
                <MaterialReactTable
                  enableToolbarInternalActions={true} //las acciones al lado del search (agregar y full screen)
                  enableGrouping // para permitir agrupar x estado x ej
                  layoutMode="grid"
                  muiTableHeadCellProps={tableHeadCellProps}
                  muiTableBodyCellProps={({ row }) => ({
                    align: "left",
                    //   sx: {
                    //     backgroundColor:
                    //       row.getValue("estado_stock") === 0
                    //         ? ""
                    //         : row.getValue("estado_stock") === 1
                    //         ? "rgb(255,105,97)"
                    //         : "rgb(253,253,150)",
                    //     color: "black",
                    //     borderColor: "black",
                    //   },
                  })}
                  enableColumnFilters={false} //desactiva filtros x  columna
                  enableHiding={false} // opcion de ocultar columna pero activando el enablecolumaction
                  enableDensityToggle={false} //
                  localization={MRT_Localization_ES} //idioma
                  enableColumnDragging={false} //para arrastrar columnas
                  initialState={initialState}
                  muiSearchTextFieldProps={muiSearchTextFieldProps}
                  columns={columns}
                  data={prendas} //con lo q la completas (esto cambia siempre)
                  enableStickyFooter
                  enableRowActions
                  // enableEditing  //para que se pueda editar desde tabla
                  positionActionsColumn="last" // posicion de la columna de acciones al final
                  // ACCIONES
                  renderToolbarInternalActions={(
                    { table } // boton para nuevo , al lado del buscar
                  ) => (
                    <>
                      <MRT_FullScreenToggleButton table={table} />
                    </>
                  )}
                  renderTopToolbarCustomActions={(row, table) => (
                    <>
                      <Typography variant="poster" fontSize={26}>
                        Tipos de Prendas
                      </Typography>
                    </>
                  )}
                  renderRowActions={({ row, table }) => (
                    //las acciones del costado editar y ver
                    <>
                      <div>
                        <Tooltip arrow placement="left" title="Talles">
                          <IconButton
                            onClick={() => {
                              navigate("/talles_prendas/", {
                                state: row.original,
                              });
                            }}
                            color="secondary"
                          >
                            <CheckroomIcon />
                          </IconButton>
                        </Tooltip>
                        <Tooltip arrow placement="right" title="Editar">
                            <IconButton
                              onClick={() => {
                                // closeMenu();
                                setPrenda(row.original);
                                setEditar(true);
                              }}
                              color="primary"
                            >
                              <EditIcon />
                            </IconButton>
                          </Tooltip>
                      </div>
                    </>
                  )}
                />
              </ThemeProvider>
            </Box>
          ) : null}
        </Container>
        {editar && 
        <EdicionPrenda
        open={editar}
        // setOpen={setEditar}
        onClose={handleClose}
        prenda={prenda}
        />
        }
      </>
  )
}

export default Prendas_rrhh